export default "__VITE_ASSET__xwd7bgwv__"